import type { RoleConfig } from '../types.js';

export const jailer: RoleConfig = {
  id: 'jailer',
  faction: 'town',
  title: { ru: 'Тюремщик', uk: 'Тюремник' },
  latin: 'JAILER',
  number: '53',
  accent: '#9aa3ad',
  sub: '#3a4048',
  ability: {
    ru: 'Ночью забирает игрока в камеру: тот не может действовать и не может погибнуть.',
    uk: 'Уночі забирає гравця до камери: той не може діяти й не може загинути.',
  },
  abilities: [
    { key: 'jail', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
  // Resolves between distract and frame — see room.ts step 2.5.
};
